import React from "react";

import { PaymentMethodForm } from "components";
import { CopyInfoData, CreditCardTypes, PaymentMethodValues } from "types";

import {
	accountNumberFieldName,
	bankAccountFieldName,
	bankFieldName,
	cardHolderNameFieldName,
	cardNumberFieldName,
	cardTypeFieldName,
	cvvFieldName,
	paymentTypeFieldName,
	routingNumberFieldName,
	expirationDateFieldName,
	payeeFirstNameFieldName,
	payeeLastNameFieldName,
	paymentMethodStatusFieldName,
	customerIdFieldName,
} from "../paymentMethodForm/paymentMethodConstants";

type AddPaymentMethodFormProps = {
	entityId: string | number;
	onSuccess: Function;
	submitService: Function;
	copyInfoData?: CopyInfoData;
	isLoadingCopyInfoData?: boolean;
	preSelectedValues?: PaymentMethodValues;
	isModal?: boolean;
	isApplication?: boolean;
	isBillToAgent?: boolean;
};

export const AddPaymentMethodForm = ({
	entityId,
	onSuccess,
	submitService,
	copyInfoData,
	isLoadingCopyInfoData,
	preSelectedValues,
	isModal,
	isApplication,
	isBillToAgent,
}: AddPaymentMethodFormProps) => {
	const defaultValues = {
		[paymentTypeFieldName]: null,
		[paymentMethodStatusFieldName]: true,
		//ach
		[routingNumberFieldName]: undefined,
		[accountNumberFieldName]: "",
		[bankAccountFieldName]: "",
		[bankFieldName]: "",
		//credit card
		[customerIdFieldName]: null,
		[cardHolderNameFieldName]: "",
		[expirationDateFieldName]: "",
		[cvvFieldName]: "",
		[cardNumberFieldName]: "",
		[cardTypeFieldName]: CreditCardTypes.Unknown.name,
		[payeeFirstNameFieldName]: "",
		[payeeLastNameFieldName]: "",
		...preSelectedValues,
	};

	return (
		<PaymentMethodForm
			defaultValues={defaultValues}
			isLoading={false}
			entityId={entityId}
			onSuccess={onSuccess}
			submitService={submitService}
			copyInfoData={copyInfoData}
			isLoadingCopyInfoData={isLoadingCopyInfoData}
			isModal={isModal}
			isApplication={isApplication}
			isBillToAgent={isBillToAgent}
		/>
	);
};
